import { Container } from "react-bootstrap";
import {
    IPAddressSection,

} from "./ipAddressStyle"
const IpAddress = () => {
  return (
      <IPAddressSection>
      <Container className="cont-w">
         Your IP address is blocked
         </Container>
      </IPAddressSection> 
  )
}

export default IpAddress
